import useRestrictionCheck from "../hooks/useRestrictionCheck.hook";

export default function RestrictionCheckComp() {
  useRestrictionCheck();

  return null;
}
